import { render, staticRenderFns } from "./ConsentConfigModal.vue?vue&type=template&id=44aaf472&scoped=true"
import script from "./ConsentConfigModal.vue?vue&type=script&lang=js"
export * from "./ConsentConfigModal.vue?vue&type=script&lang=js"
import style0 from "./ConsentConfigModal.vue?vue&type=style&index=0&id=44aaf472&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44aaf472",
  null
  
)

export default component.exports